import { httpDelete, httpGet, httpPost, httpPut } from "./AbstractService";
import clone from "lodash-es/clone";
import { getPeriodDetails } from "./SchoolService";
import { paddy } from "./StringService";
import ENDPOINTS from "../data/endpoints.json";

export const getTeacherCoursesForDateRange = (
  school,
  jwt,
  startYYYYMMDD,
  endYYYYMMDD,
  eid = null
) => {
  let url = `${ENDPOINTS[school.region].course}/teacher/course/date/${startYYYYMMDD}/${endYYYYMMDD}`;

  if (eid != null) {
    url += "?eid=" + eid;
  }
  return httpGet( jwt, url);
};

export const getStudentCoursesForDateRange = (
  school,
  jwt,
  startYYYYMMDD,
  endYYYYMMDD
) => {
  return httpGet(
    
    jwt,
    `${ENDPOINTS[school.region].course}/student/course/date/${startYYYYMMDD}/${endYYYYMMDD}`
  );
};

export const createCourseEntry = (school, courseDate) => {
  const event = clone(courseDate);

  // set the fullcalendar fields
  event.title = `${event.name} (${event.schoolLocationName})`;
  // signup date is the global input value passed to this component
  // also need to append hh:mm:ss to the signup date for
  event.start = `${courseDate.date} ${getCourseStartTime(school, courseDate)}`;
  event.end = `${courseDate.date} ${getCourseEndTime(school, courseDate)}`;
  return event;
};

export const getCourseStartTime = (school, courseDate) => {
  const schoolPeriodDetails = getPeriodDetails(school, courseDate.period - 1);
  return `${paddy(schoolPeriodDetails.startHour, 2, "0")}:${paddy(
    schoolPeriodDetails.startMinute,
    2,
    "0"
  )}`;
};

// factors in the periodLength
export const getCourseEndTime = (school, courseDate) => {
  const schoolPeriodDetails = getPeriodDetails(
    school,
    courseDate.period - 1 + courseDate.periodLength - 1
  );
  return `${paddy(schoolPeriodDetails.endHour, 2, "0")}:${paddy(
    schoolPeriodDetails.endMinute,
    2,
    "0"
  )}`;
};

export const getCourseDate = (school, jwt, eid) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].course}/course/date/${eid}`);
};

export const getCourseTime = (school, courseDate) => {
  console.log(courseDate);
  if (courseDate == null) {
    return ``;
  }
  return `${getCourseStartTime(school, courseDate)} - ${getCourseEndTime(
    school,
    courseDate
  )}`;
};

export const getCourseDateStudents = (school, jwt, eid) => {
  return httpGet(
    
    jwt,
    `${ENDPOINTS[school.region].course}/course/date/${eid}/student`
  );
};

export const updateCourseAttendance = (
  school,
  jwt,
  courseDateEid,
  presentEids,
  lateEids,
  absentEids
) => {
  return httpPost(
    
    jwt,
    `${ENDPOINTS[school.region].course}/course/date/${courseDateEid}/delta`,
    {
      absent_eids: absentEids,
      present_eids: presentEids,
      late_eids: lateEids,
    }
  );
};

export const getTeacherCourses = (school, jwt, eid) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].course}/teacher/course/${eid}`);
};

export const adminSaveTeacherCourse = (
  school,
  jwt,
  eid,
  teacherEid,
  name,
  url,
  joinCode,
  locationEid,
  periodLength
) => {
  const values = { eid, name, url, joinCode, locationEid, periodLength };
  if (eid == null) {
    return httpPost(
      
      jwt,
      `${ENDPOINTS[school.region].course}/teacher/course/${teacherEid}`,
      values
    );
  }

  // update existing
  return httpPut(
    
    jwt,
    `${ENDPOINTS[school.region].course}/teacher/course/${teacherEid}`,
    values
  );
};

export const adminRemoveTeacherCourse = (school, jwt, eid) => {
  return httpDelete(jwt, `${ENDPOINTS[school.region].course}/course/${eid}`);
};

export const getCourseDetails = (school, jwt, eid) => {
  return httpGet( jwt, `${ENDPOINTS[school.region].course}/course/${eid}`);
};

export const adminAddCourseStudents = (school, jwt, eid, studentEids) => {
  return httpPost(
    
    jwt,
    `${ENDPOINTS[school.region].course}/course/${eid}/student`,
    { studentEids }
  );
};

export const adminRemoveCourseStudents = (school, jwt, eid, entryIds) => {
  return httpPut(
    
    jwt,
    `${ENDPOINTS[school.region].course}/course/${eid}/student`,
    { entryIds }
  );
};

export const adminGetTeacherCoursesForDateRange = (
  school,
  jwt,
  startYYYYMMDD,
  endYYYYMMDD,
  eid = null
) => {
  let url = `${ENDPOINTS[school.region].course}/admn2/teacher/course/date/${startYYYYMMDD}/${endYYYYMMDD}`;

  if (eid != null) {
    url += "?eid=" + eid;
  }
  return httpGet( jwt, url);
};

export const adminAddDateCourses = (
  school,
  jwt,
  teacherEid,
  courseEid,
  periodId,
  days,
  startDate,
  endDate
) => {
  let url = `${ENDPOINTS[school.region].course}/admn2/teacher/course/date/${startDate}/${endDate}`;
  return httpPost( jwt, url, { teacherEid, courseEid, periodId, days });
};

export const adminRemoveDateCourse = (
  school,
  jwt,
  courseDateEid,
  startDate,
  endDate
) => {
  let url = `${ENDPOINTS[school.region].course}/admn2/teacher/course/date/${startDate}/${endDate}`;
  return httpPut( jwt, url, { courseDateEid });
};

export const getSchoolCoursePeriods = (school, jwt) => {
  let url = `${ENDPOINTS[school.region].course}/school/course/period`;
  return httpGet( jwt, url);
};


export const getSchoolCoursesForDateRange = (
  school,
  jwt,
  startYYYYMMDD,
  endYYYYMMDD
) => {
  return httpGet(
    
    jwt,
    `${ENDPOINTS[school.region].course}/school/course/date/${startYYYYMMDD}/${endYYYYMMDD}`
  );
};